import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { getAdminPost, deletePost } from "@/lib/posts.functions";
import { PostEditor } from "@/components/PostEditor";
import { ArticleSourceSuggester } from "@/components/ArticleSourceSuggester";

const searchSchema = z.object({
  tool: z.enum(["sources", "translate-en", "seo-meta"]).optional(),
  apply: z.preprocess((v) => v === true || v === "true", z.boolean()).optional(),
});

export const Route = createFileRoute("/admin/$id")({
  validateSearch: searchSchema,
  component: EditPost,
});

function EditPost() {
  const { id } = Route.useParams();
  const { tool, apply } = Route.useSearch();
  const navigate = useNavigate();
  const fetchPost = useServerFn(getAdminPost);
  const del = useServerFn(deletePost);
  const { data, isLoading } = useQuery({
    queryKey: ["admin-post", id],
    queryFn: () => fetchPost({ data: { id } }),
  });
  if (isLoading) return <p className="text-sm text-ink/60">Yükleniyor...</p>;
  if (!data) return <p className="text-sm text-clay">Bulunamadı</p>;
  const onDelete = async () => {
    const title = data.title_tr || data.title_en || data.slug;
    if (!confirm(`"${title}" kalıcı olarak silinsin mi? Bu işlem geri alınamaz.`)) return;
    await del({ data: { id } });
    navigate({ to: "/admin/icerik" });
  };
  return (
    <>
      <div className="flex justify-end mb-3">
        <button
          onClick={onDelete}
          className="text-xs px-3 py-1.5 rounded-full border border-clay/40 text-clay hover:bg-clay hover:text-paper"
        >
          Yazıyı sil
        </button>
      </div>
      <PostEditor
        initial={data}
        initialTab={tool === "translate-en" ? "en" : "tr"}
        autoTranslate={tool === "translate-en"}
        autoSaveTranslation={tool === "translate-en" && apply === true}
        autoRewriteSeo={tool === "seo-meta" && apply === true}
        focusTool={tool}
      />
      <ArticleSourceSuggester
        postId={id}
        autoStart={tool === "sources"}
        autoAppendVerified={tool === "sources" && apply === true}
        emphasized={tool === "sources"}
      />
    </>
  );
}
